export default __webpack_public_path__ + "static/media/test-graph.8b7b2cd8.png";